import _ from 'lodash';

import {
  fetchTeacherServices,
  fetchAgeLevels,
  fetchSpecializations,
  fetchSkillLevels,
} from 'actions/metaActions';

import store from '../reduxStore';
import {
  clearRescheduleObject,
  clearReservationError,
  clearRescheduleError,
  clearCancellationError,
} from '../actions/reservationActions';


export function onHomeEnter(nextState, replace, callback) {
  replace('/schedule-lesson');
  return callback && callback();
}

export function onReservationsEnter() {
  store.dispatch(clearRescheduleObject());
}

export function onReservationsLeave() {
  store.dispatch(clearRescheduleError());
  store.dispatch(clearCancellationError());
}

export function onProfileEnter() {
  store.dispatch(clearRescheduleObject());
}

export function onTeacherLeave() {
  store.dispatch(clearReservationError());
}

export function onTeacherListingsEnter() {
  const state = store.getState();

  if (_.isEmpty(state.meta.services)) {
    store.dispatch(fetchTeacherServices());
  }

  if (_.isEmpty(state.meta.ageLevels)) {
    store.dispatch(fetchAgeLevels());
  }

  if (_.isEmpty(state.meta.specializations)) {
    store.dispatch(fetchSpecializations());
  }
}

export function onTeacherProfileEnter() {
  const state = store.getState();

  if (_.isEmpty(state.meta.services)) {
    store.dispatch(fetchTeacherServices());
  }

  if (_.isEmpty(state.meta.skillLevels)) {
    store.dispatch(fetchSkillLevels());
  }
}



// WEBPACK FOOTER //
// ./src/utils/routeUtils.js